'use client';

import React from 'react';
import { TasticProps } from '../types';
import TnCTextOnlyBanner,  { TnCTextOnlyProps } from 'components/commercetools-ui/organisms/tnc-text-only-banner';

const TNCTextOnlyBannerTastic = ({ data }: TasticProps<TnCTextOnlyProps>) => {

  return (
    <TnCTextOnlyBanner {...data} />
  );
};

export default TNCTextOnlyBannerTastic;
